<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Manage Partner Campaigns</h1>
  </div>
  <div class="flex flex-row justify-end gap-3 pb-4">
    <button nz-button nzType="primary" [routerLink]="['/campaigns/add']">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Create Partner Campaigns
    </button>
  </div>
  <div class="flex flex-row justify-end mb-3">
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for title"
        />
      </nz-input-group>
    </div>
  </div>

  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="searchGlobal()"
    >
      Search
    </button>
  </ng-template>
  <ng-template #tableHead>
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <span class="font-bold">Partner Campaigns</span>
      </div>
      <div class="flex gap-2">
        <div nz-col>
          <nz-switch
            [(ngModel)]="hideTestCampaign"
            (ngModelChange)="testCampaignFilter($event)"
            nzCheckedChildren="Show Test Campaigns"
            nzUnCheckedChildren="Hide Test Campaigns"
            class="mr-3"
          ></nz-switch>
        </div>
        <div nz-col>
          <button
            class="btn-color"
            nz-button
            nzSize="small"
            nzType="primary"
            (click)="resetFilter()"
          >
            Clear filter
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <nz-spin [nzSpinning]="pageLoading" nzTip="Fetching Partner Campaigns......">
    <nz-table
      #Table
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzData]="data"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalCount"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="pageNo"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>Title</th>
          <!-- <th>Description</th> -->
          <th>
            Partner
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="PartnerMenu">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th>
            Presenter
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="PresenterMenu">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th
            nzColumnKey="startDate"
            [nzSortFn]="true"
            [nzCustomFilter]="true"
            nzSortOrder="descend"
            (nzSortOrderChange)="campaignDateSort($event)"
          >Campaign On
              <nz-filter-trigger
          [nzActive]="true"
          [nzDropdownMenu]="dateFilterMenu"
        >
          <span nz-icon nzTheme="outline" nzType="schedule"></span>
        </nz-filter-trigger>
          </th>
          <th>Status</th>
          <th>Created At</th>
          <th nzWidth="25%">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data">
          <td>
            {{ data.title }}
          </td>
          <!-- <td>
            {{ data.descripiton }}
          </td> -->
          <td>
            {{ data.partnerName }}
          </td>
          <td>
            {{ data.presenterNames.join(', ') }}
          </td>
          <td>
            {{ formatDate(data.startDate) }}
          </td>
          <td>
            <nz-tag [nzColor]="data.isVisible ? 'green' : 'red'">
              {{ data.isVisible ? 'Active' : 'Inactive' }}
            </nz-tag>
          </td>
          <td>
            {{ utils.convertEpochToFormattedDate(data.createdAt) }}
          </td>
          <td nzRight>
            <div class="flex items-center justify-evenly">
              <span nz-tooltip nzTooltipTitle="View Campaign">
                <button
                  [routerLink]="['/campaigns/view/' + data.id]"
                  nz-button
                  nzType="primary"
                  nzShape="circle"
                >
                  <span nz-icon nzType="eye" nzTheme="outline"></span>
                </button>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>
<nz-dropdown-menu #PartnerMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Partners</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="partnerFilter($event)">
          <div *ngFor="let tag of partnersCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="tag.value"
                [ngModel]="tag.checked"
                >{{ tag.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #PresenterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Presenters</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="presenterFilter($event)">
          <div *ngFor="let tag of presentersCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="tag.value"
                [ngModel]="tag.checked"
                >{{ tag.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #dateFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="ng-row">
      <nz-range-picker
        [nzFormat]="dateFormat"
        [(ngModel)]="campaignColumnFilterDate"
        (ngModelChange)="onEventsFilterDateChange($event)"
      ></nz-range-picker>
    </div>
    <div nz-row class="mt-5 gap-4" nzJustify="end">
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="getData()"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>